/** @format */

import { ITermsOfServiceModalProps } from "./TermsOfServiceModal.types";
import { Modal } from "antd";
import React from "react";
import TermsOfService from "./TermsOfService";

const TermsOfServiceModalView: React.FC<ITermsOfServiceModalProps> = ({
	isVisible: visible,
	onAcceptTermsOfUse,
}) => (
	<Modal
		cancelButtonProps={{ style: { display: "none" } }}
		closable={false}
		onOk={onAcceptTermsOfUse}
		okText="Accept"
		title="Terms of Service"
		open={visible}>
		<TermsOfService />
	</Modal>
);

export default TermsOfServiceModalView;
